import clsx from 'clsx';

const skeletonVariants: Record<string, string> = {
  text:    'h-4 rounded-lg',
  title:   'h-6 rounded-lg',
  heading: 'h-8 rounded-xl',
  avatar:  'h-10 w-10 rounded-full',
  image:   'h-48 w-full rounded-2xl',
  button:  'h-10 w-24 rounded-xl',
  input:   'h-10 w-full rounded-xl',
};

export interface SkeletonProps {
  variant?: keyof typeof skeletonVariants;
  className?: string;
}

export function Skeleton({ variant, className }: SkeletonProps) {
  return (
    <div
      className={clsx(
        'animate-pulse bg-white/5',
        variant ? skeletonVariants[variant] : 'h-4 w-full rounded-lg',
        className,
      )}
    />
  );
}
